/* eslint-disable import/named */
import { call, put, takeEvery } from "redux-saga/effects";
import * as types from "../../constants";

import * as Services from "./service";

// const storeReducer = (state) => state.get("storeReducer");

function* getListTemplateCampaign() {
  try {
    const response = yield call(Services.getListTemplateCampaignService);
    yield put({ type: types.GET_LIST_TEMPLATE_RESPONSE, data: response });
  } catch (error) {
    yield put({ type: types.GET_LIST_TEMPLATE_RESPONSE, error });
  }
}

function* getListCampaignByType(actions) {
  try {
    const response = yield call(
      Services.getListCampaignByTypeService,
      actions.payload,
    );
    yield put({
      type: types.GET_LIST_CAMPAIGN_BY_TYPE_RESPONSE,
      data: response,
    });
  } catch (error) {
    yield put({ type: types.GET_LIST_CAMPAIGN_BY_TYPE_RESPONSE, error });
  }
}

function* sendTestEmail(actions) {
  try {
    const response = yield call(Services.sendTestEmail, actions.payload);
    yield put({ type: types.SEND_TEST_EMAIL_RESPONSE, data: response });
  } catch (error) {
    yield put({ type: types.SEND_TEST_EMAIL_RESPONSE, error });
  }
}

function* saveSettingCampaign(actions) {
  try {
    const response = yield call(Services.saveSettingCampaign, actions.payload);
    yield put({ type: types.SAVER_SETTING_CAMPAIGN_RESPONSE, data: response });
  } catch (error) {
    yield put({ type: types.SAVER_SETTING_CAMPAIGN_RESPONSE, error });
  }
}

function* activeDisableCampaign(id, status) {
  try {
    const response = yield call(Services.activeDisableCampaign, id, status);
    yield put({ type: "ACTIVE_DISABLE_CAMPAIGN_RESPONSE", data: response });
  } catch (error) {
    yield put({ type: "ACTIVE_DISABLE_CAMPAIGN_RESPONSE", error });
  }
}

function* deleteCampaign(id) {
  try {
    const response = yield call(Services.deleteCampaign, id);
    yield put({ type: "DELETE_CAMPAIGN_RESPONSE", data: response });
  } catch (error) {
    yield put({ type: "DELETE_CAMPAIGN_RESPONSE", error });
  }
}

function* getDataDesignSelected(id) {
  try {
    const response = yield call(Services.getDataDesignSelected, id);
    yield put({ type: "DATA_DESIGN_SELECTED_RESPONSE", data: response });
  } catch (error) {
    yield put({ type: "DATA_DESIGN_SELECTED_RESPONSE", error });
  }
}

function* getCampaignData(id) {
  try {
    const response = yield call(Services.getCampaignData, id);
    yield put({ type: "GET_CAMPAIGN_DATA_RESPONSE", data: response });
  } catch (error) {
    yield put({ type: "GET_CAMPAIGN_DATA_RESPONSE", error });
  }
}

function* sagaActions() {
  yield takeEvery(types.GET_CAMPAIGN_DATA, getCampaignData);
  yield takeEvery(types.GET_DATA_DESIGN_SELECTED, getDataDesignSelected);
  yield takeEvery(types.DELETE_CAMPAIGN, deleteCampaign);
  yield takeEvery(types.ACTIVE_DISABLE_CAMPAIGN, activeDisableCampaign);
  yield takeEvery(types.SAVER_SETTING_CAMPAIGN, saveSettingCampaign);
  yield takeEvery(types.GET_LIST_CAMPAIGN_BY_TYPE, getListCampaignByType);
  yield takeEvery(types.SEND_TEST_EMAIL, sendTestEmail);
  yield takeEvery(types.GET_LIST_TEMPLATE, getListTemplateCampaign);
}

export default sagaActions;
